import React from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import MaterialList from "./MaterialList";
import MaterialTypeTree from "./MaterialTypeTree";

export default function () {
    return (
        <div style={{height: "98%"}}>
            {/* display: "flex" */}
            <Card
                title={<h3>商品类型</h3>}
                bordered={true}
                className="margin-top-8"
                style={{width: "200px", height: "100%",float:"left"}}
            >
                <MaterialTypeTree/>
            </Card>
            <div className="margin-top-8 margin-left-8" style={{width:"calc(100% - 210px)",float:"right"}}>
                <Card
                    bordered={true}
                    // style={{display: "flex"}}
                >
                    <SearchForm/>
                </Card>
                <MaterialList/>
            </div>
        </div>
    )
}